import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ReactComponent as BilbioLogo } from "../../assets/NewLogo.svg";
import OgImage from "../../assets/landingPages/homePage/Hero.png";
import PassWordImg from "../../assets/authPages/forgotPassRightImg.png";

import { ReactComponent as EyeIcon } from "../../assets/settingPage/eye.svg";
import { ReactComponent as CloseEyeIcon } from "../../assets/settingPage/eye-slash.svg";
import { toast } from "react-hot-toast";

import axios from "axios";
import { Helmet } from "react-helmet";

const baseUrl = process.env.REACT_APP_API_URL;

const NewPassword = () => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();
  const [isLoading, setIsLoading] = useState(false);
  const { id, token } = useParams();
  const [showOpassword, setShowOpassword] = useState(true);
  const [showCpassword, setShowCpassword] = useState(true);

  const navigate = useNavigate();

  const onSubmits = async (data) => {
    setIsLoading(true);
    const emailData = {
      password: data.password,
      password_confirmation: data.confirmPassword,
    };

    try {
      const path = `/api/user/reset-password/${id}/${token}`;
      const url = baseUrl + path;
      const response = await axios.post(url, emailData);
      setIsLoading(false);
      const result = response?.data?.message;
      const status = response?.data?.status;
      if (status === "success") {
        toast.success(result);
        navigate("/auth/login");
      }
      if (status === "failed") {
        toast.error(result);
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error);
      toast.error(error);
    }
  };

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Create Password | Bil.Bio</title>
        <meta property="og:title" content="Create Password | Bil.Bio" />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:image" content={window.location.origin + OgImage} />
        <meta property="og:description" content="Create Bio Link page" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Bil.Bio" />
        <meta
          name="twitter:description"
          content="Bil.Bio | All links in link"
        />
        <meta name="twitter:site" content="@BilBioHQ" />
        <meta name="twitter:image" content={window.location.origin + OgImage} />
      </Helmet>
      <div className="flex flex-col lg:flex-row relative">
        <div className="fixed top-5 left-4 sm:top-8 sm:left-8 p-2 bg-white">
          <Link to={"/"} className="flex items-center w-[80px] lg:w-[121px]">
            <BilbioLogo className="w-full h-auto" />
          </Link>
        </div>
        <div className="flex mt-[136px] sm:mt-0 sm:items-center p-6 sm:p-12  w-full min-h-screen h-screen overflow-y-auto xsmfold:px-2 xsml:px-5 smm:px-12 md:px-32 lg:px-16 xl:px-28 2xl:px-44">
          <div className="w-full xsmfold:mt-10 md:mt-0">
            <h4 className="mb-1 sm:mb-2 text-custom_h5 sm:text-custom_h4 text-center text-heading_color dark:text-color_v1_dark">
              Set New Password
            </h4>
            <h6 className="text-center text-small2 sm:text-small1 text-font_light_color dark:text-color_v2_dark mb-[50px] sm:mb-12">
              Enter password to Reset your password.
            </h6>
            <form onSubmit={handleSubmit((data) => onSubmits(data))}>
              <div className="flex flex-col gap-4">
                <div>
                  <label
                    htmlFor="password"
                    className="block ml-2 mb-[1.5px] sm:mb-2 text-small2 sm:text-body_copy2 text-heading_color dark:text-color_v2_dark"
                  >
                    Password
                  </label>

                  <div className="relative">
                    <input
                      type={showOpassword ? "password" : "text"}
                      id="password"
                      {...register("password", {
                        required: "Password Required",
                        pattern: {
                          value:
                            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                          message:
                            "Password must contain at least 8 characters, including 1 uppercase letter, 1 lowercase letter, 1 special character, and 1 numeric value.",
                        },
                      })}
                      className={`text-small2 sm:text-body_copy2 border rounded-md  focus:outline-none block w-full p-[13px] sm:p-[15px] py-[5px] sm:py-[7px] ${
                        errors?.password
                          ? "border-state_color_error placeholder:text-state_color_error"
                          : "border-light_bg_v2 bg-transparent focus:border-font_light_color focus:placeholder:text-heading_color"
                      }`}
                      placeholder="Enter Password"
                    />

                    <div
                      onClick={() => setShowOpassword(!showOpassword)}
                      className="absolute flex justify-center items-center inset-y-0 end-[15px] cursor-pointer"
                    >
                      {showOpassword ? (
                        <CloseEyeIcon
                          className={`${
                            errors?.password
                              ? "stroke-state_color_error"
                              : "stroke-[#292D32]"
                          }`}
                        />
                      ) : (
                        <EyeIcon
                          className={`${
                            errors?.password
                              ? "stroke-state_color_error"
                              : "stroke-[#292D32]"
                          }`}
                        />
                      )}
                    </div>
                  </div>
                  {errors?.password && (
                    <small className="text-state_color_error text-small3">
                      {errors?.password?.message}
                    </small>
                  )}
                </div>
                <div>
                  <label
                    htmlFor="cpassword"
                    className="block ml-2 mb-1 text-base text-stone-700 dark:text-color_v2_dark xsmfold:text-sm xsmm:text-base"
                  >
                    Confirm Password
                  </label>

                  <div className="relative">
                    <input
                      type={showCpassword ? "password" : "text"}
                      id="cpassword"
                      {...register("confirmPassword", {
                        required: {
                          value: true,
                          message: "Confirm password required",
                        },
                        validate: (value) =>
                          value === watch("password") ||
                          "Passwords do not match",
                      })}
                      className={`text-small2 sm:text-body_copy2 border rounded-md  focus:outline-none block w-full p-[13px] sm:p-[15px] py-[5px] sm:py-[7px] ${
                        errors?.confirmPassword
                          ? "border-state_color_error placeholder:text-state_color_error"
                          : "border-light_bg_v2 bg-transparent focus:border-font_light_color focus:placeholder:text-heading_color"
                      }`}
                      placeholder="Enter Confirm Password"
                    />

                    <div
                      onClick={() => setShowCpassword(!showCpassword)}
                      className="absolute flex justify-center items-center inset-y-0 end-[15px] cursor-pointer"
                    >
                      {showCpassword ? (
                        <CloseEyeIcon
                          className={`${
                            errors?.password
                              ? "stroke-state_color_error"
                              : "stroke-[#292D32]"
                          }`}
                        />
                      ) : (
                        <EyeIcon
                          className={`${
                            errors?.password
                              ? "stroke-state_color_error"
                              : "stroke-[#292D32]"
                          }`}
                        />
                      )}
                    </div>
                  </div>
                  {errors?.confirmPassword && (
                    <small className="text-state_color_error text-small3">
                      {errors?.confirmPassword?.message ||
                        errors?.confirmPassword?.required?.message}
                    </small>
                  )}
                </div>
              </div>

              <button
                type="submit"
                className={`mt-[50px] sm:mt-12 bg-main_color text-white rounded-full w-full p-2 sm:p-2.5 ${
                  isLoading ? "opacity-70" : ""
                }`}
              >
                {isLoading ? (
                  <svg
                    aria-hidden="true"
                    role="status"
                    className="inline w-4 h-4 mr-3 text-white animate-spin"
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="#E5E7EB"
                    />
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="currentColor"
                    />
                  </svg>
                ) : (
                  "SET PASSWORD"
                )}
              </button>
            </form>
          </div>
        </div>
        <div className="hidden lg:block md:h-auto md:w-full  h-screen">
          <img
            className="object-cover w-full h-screen"
            src={PassWordImg}
            alt="..."
            title="Image"
          />
        </div>
      </div>
    </>
  );
};

export default NewPassword;
